<div class="calendar-container">
    <!-- Top bar -->
    <div class="top-bar">
      <div class="tab-pane left">
        <button (click)="goToDateFacilityFlow()">Facility</button>
        <button class="active">Timeslot</button>
      </div>
      <div class="logo-container">
        <img src="assets/img/logo_negative.png" alt="Logo" style="height: 30px; display: block; margin: 0 auto;" />
      </div>
      <span class="username">Time registrering</span>

      <div class="user-info">
        <div class="logout"><button class="logout-button" (click)="logout()">Logout</button>
        </div>
      </div>
    </div>

    <!-- Content area -->
    <div class="content">
      <div class="top">
      <!-- Facilities dropdown -->

      <select
        id="facilitySelect"
        class="facility-select"
        (change)="onFacilityChange($event)">
        <option value="" disabled selected>Select facility</option>

        <option *ngFor="let facility of facilities" [value]="facility.id">
          {{ facility.name }}
        </option>
      </select>

      <!-- Month navigation -->
      <div class="month-navigation">
        <button class="nav-button" (click)="prevMonth()">&lt;</button>
        <span class="month-year">
          {{ monthNames[currentMonth] }} {{ currentYear }}
        </span>
        <button class="nav-button" (click)="nextMonth()">&gt;</button>
      </div>

      <!-- Calendar grid -->
      <div class="calendar-grid">
        <div
          class="calendar-day"
          *ngFor="let day of daysInMonth"
          [class.selected]="day === selectedDay"
          (click)="selectDay(day)"
          (keyup)="selectDay(day)"
          tabindex="0"
        >
          {{ day }}
        </div>
      </div>
    </div>

    <!-- Chosen date label -->
    <div class="date-label">
      {{ selectedDay }} {{ monthNames[currentMonth] }} {{ currentYear }}
    </div>

    <div class="bottom">

      <!-- Time list -->
<div *ngIf="!detections || detections.length === 0" class="empty-detections">
  Please select facility
</div>

      <!-- Time list -->
      <div class="time-list">
        <div
          class="time-item"
          *ngFor="let detection of detections; let i = index"
          (click)="openModal(detection)"
          (keyup)="openModal(detection)"
          tabindex="0"
          >
          <div class="time-range">{{ detection.startTime | date: 'HH:mm' }} - {{ detection.endTime | date: 'HH:mm' }}</div>
          <div class="persons">
            {{ detection.count === null ? '-' : detection.count }}
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>

  <!-- Modal Backdrop -->
  <div class="modal-backdrop" *ngIf="showModal"></div>

  <!-- Modal Window -->
  <div class="modal-window" *ngIf="showModal">
    <div class="modal-header">
      {{ selectedTimeSlotLabel }}
    </div>
    <div class="modal-body">
      <label for="personsInput">Persons:</label>
      <input
        type="number"
        id="personsInput"
        [(ngModel)]="count"
        placeholder="Enter number"
      />
    </div>
    <div class="modal-footer">
      <button class="close-button" (click)="closeModal()">Close</button>
      <button class="save-button" (click)="savePersons()">Save</button>
    </div>
  </div>
